import React, { useEffect, useState } from 'react';
import { Box, Button, Grid } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSync } from '@fortawesome/pro-duotone-svg-icons';
import { useForm } from 'react-hook-form';
import Axios from 'axios';
import { endOfDay } from 'date-fns';
import { useSnackbar } from 'notistack';
import { TitleLabel } from '../../Element/LabelInputForm';
import { MySelect } from '../../Select/Select';
import {
   groups_mock,
   fields_mock,
   departments_mock,
   segments_mock,
   branches_mock,
} from '../../../mockdata/dashboard/mock-graph-1';
import { DatePicker } from 'react-nice-dates';
import { enUS } from 'date-fns/locale';
import 'react-nice-dates/build/style.css';
import dayjs from 'dayjs';
import { Input } from '../../../assets/styled/Element';
import moment from 'moment';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import CircularProgress from '@material-ui/core/CircularProgress';

const Filter6level = ({
   onSubmit,
   isLoading = false,
   defaultSubmitFirstParams = false,
   startDate = new Date(moment().subtract(1, 'years')),
   endDate = new Date(),
}) => {
   const {
      control,
      register,
      watch,
      setValue,
      getValues,
      handleSubmit,
      unsubscribe,
   } = useForm({
      defaultValues: {
         pointType: ['B'], // select multiple
         // pointType: 'G', // select one
         startDate: startDate,
         endDate: endDate,
      },
   });

   const selectStartDate = watch('startDate');
   const selectEndDate = watch('endDate');
   const selectPointType = watch('pointType');

   useEffect(() => {
      register({ name: 'pointType' });
      register({ name: 'startDate' });
      register({ name: 'endDate' });
   }, [register]);

   useEffect(() => {
      init();
   }, []);

   const init = () => {
      if (defaultSubmitFirstParams) {
         handleSubmit(submit)();
      }
   };

   const handleStartDateChange = (e) => setValue('startDate', e);
   const handleEndDateChange = (type) => (e) => {
      if (type === 'auto') setValue('endDate', endOfDay(e));
      else setValue('endDate', e);
   };
   const handleAlignment = (event, pointType) => {
      /* select multiple */
      setValue('pointType', pointType);

      /* select only one */
      // if (pointType !== null) {
      //     setValue('pointType', pointType);
      // }
   };

   const handleReset = () => {
      setValue('pointType', ['B']);
      setValue('startDate', startDate);
      setValue('endDate', endDate);
      init();
   };

   const submit = async (e) => {
      let params = e;
      params.pointType = e.pointType;
      params.startDateString = moment(e.startDate).format('DD/MM/YYYY');
      params.endDateString = moment(e.endDate).format('DD/MM/YYYY');
      onSubmit(params);
   };

   return (
      <form onSubmit={handleSubmit(submit)}>
         <Box fontSize={20}>
            <Grid container spacing={2}>
               <Grid item xs={6}>
                  <TitleLabel Fs={'14px'}>ประเภท&nbsp;:&nbsp;</TitleLabel>
                  <Box width='100%'>
                     <ToggleButtonGroup
                        value={selectPointType}
                        onChange={handleAlignment}
                     >
                        <ToggleButton
                           value='B'
                           style={{ textTransform: 'none' }}
                        >
                           for SOCIETY
                        </ToggleButton>
                        <ToggleButton
                           value='G'
                           style={{ textTransform: 'none' }}
                        >
                           with GOVERNANCE
                        </ToggleButton>
                        <ToggleButton
                           value='S'
                           style={{ textTransform: 'none' }}
                        >
                           through DIGITALIZATION
                        </ToggleButton>
                     </ToggleButtonGroup>
                  </Box>
               </Grid>
               <Grid item xs={2}>
                  <TitleLabel Fs={'14px'}>เริ่มต้น&nbsp;:&nbsp;</TitleLabel>
                  <Box width={'100%'} style={{ position: 'relative' }}>
                     <DatePicker
                        date={selectStartDate}
                        onDateChange={handleStartDateChange}
                        locale={enUS}
                        maximumDate={getValues('endDate')}
                     >
                        {({ inputProps, focused }) => (
                           <Input
                              className={'input' + (focused ? ' -focused' : '')}
                              {...inputProps}
                              value={`${
                                 inputProps.value &&
                                 dayjs(new Date(inputProps.value)).format(
                                    'DD/MM/BBBB',
                                 )
                              }`}
                           />
                        )}
                     </DatePicker>
                  </Box>
               </Grid>
               <Grid item xs={2}>
                  <TitleLabel Fs={'14px'}>สิ้นสุด&nbsp;:&nbsp;</TitleLabel>
                  <Box width={'100%'} style={{ position: 'relative' }}>
                     <DatePicker
                        date={selectEndDate}
                        onDateChange={handleEndDateChange('auto')}
                        minimumDate={
                           getValues('startDate')
                              ? getValues('startDate')
                              : new Date()
                        }
                        locale={enUS}
                     >
                        {({ inputProps, focused }) => (
                           <Input
                              className={'input' + (focused ? ' -focused' : '')}
                              {...inputProps}
                              value={`${
                                 inputProps.value &&
                                 dayjs(new Date(inputProps.value)).format(
                                    'DD/MM/BBBB',
                                 )
                              }`}
                           />
                        )}
                     </DatePicker>
                  </Box>
               </Grid>
            </Grid>
            <Grid container spacing={2}>
               <Grid item xs={12}>
                  <Button
                     variant={'contained'}
                     size={'small'}
                     color={'primary'}
                     type={'submit'}
                     startIcon={
                        isLoading ? (
                           <CircularProgress size={20} color={'primary'} />
                        ) : (
                           <FontAwesomeIcon icon={faSearch} size={'s'} />
                        )
                     }
                     disabled={isLoading}
                  >
                     ค้นหา
                  </Button>
                  <Button
                     variant={'contained'}
                     disableElevation
                     size={'small'}
                     onClick={handleReset}
                     startIcon={<FontAwesomeIcon icon={faSync} size={'s'} />}
                  >
                     รีเฟรช
                  </Button>
               </Grid>
            </Grid>
         </Box>
      </form>
   );
};

export default Filter6level;
